import {TopicRoutingEndpointResponse} from '../../../../generated/types';

export function fetchTopics(
  supportFetch: typeof fetch,
  entryPoint: string,
): Promise<TopicRoutingEndpointResponse> {
  return supportFetch(`/api/topic-routing/${entryPoint}`).then((resp) =>
    resp.json(),
  );
}
